import { RootState } from '../../store/rootReducer';

export const RenewalOptionSelector = (state: RootState) => state.optionContract;
